enum JobClosedReason {
	Undefined = 0,
	CreatedByMistake = 1,
	RequirementsChanged = 2,
	Lost = 3,
	PartiallyPlaced = 11,
	FullyPlaced = 15,
	
}

export default JobClosedReason;